import { useSelector } from "react-redux";

export const GetLoggedUser = () => {
  // logged info
  const authState = useSelector((state) => state?.user || {});
  return authState?.user || {};
};
